module.exports = __webpack_public_path__ + "img/refunds.fa09397e.svg";